export default __webpack_public_path__ + "static/media/advikaedutechretail.420229ac.jpg";